import Vue from 'vue'
import Vuetify, { VRow } from 'vuetify/lib'
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify, {
  components: { VRow },
})

export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: colors.red.darken1, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
      },
    },
  },
})
